import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { BASE_URL } from './helper';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function Singlepost() {
    const { postId } = useParams(); // Access postId from URL parameter
    const [post, setPost] = useState({});


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${BASE_URL}/api/post/${postId}`); // Fetch data for the postId
                const jsonData = await response.json();
                setPost(jsonData);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, [postId]); // Update data when postId changes
  return (
    <div>
    <Header/>
    <div className='container cont-1'>
    <img className='cont1-img pt-5' name="image" src={post.imageUrl} alt="" />
    <h2>{post.title}</h2>
    <p>{post.description}</p>
    </div>
    <Footer/>
    </div>
  )
}
